<template>
  <div>
    <nav-bar />
    <v-container fluid>
      <v-card outlined>
        <v-card-title> Mqtt for {{ deviceId }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" ref="form">
            <v-textarea
              outlined
              label="MQTT Command"
              placeholder=" "
              rounded
              no-resize
              :rules="rules"
              v-model="command"
              :rows="3"
              :disabled="commandDisabled"
            ></v-textarea>

            <v-textarea
              outlined
              label="MQTT Response"
              placeholder=" "
              filled
              readonly
              rounded
              auto-grow
              v-model="result"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="executeCommand" :loading="loading">
            <v-icon left>mdi-powershell</v-icon>
            Execute
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import { dateFormat } from '../plugins/date';
import NavBar from '../components/NavBar';
export default {
  name: 'mqtt',
  components: { NavBar },
  data() {
    return {
      rules: [value => !!value || 'Required'],
      command: null,
      result: null,
      alert: false,
      message: '',
      loading: false,
      valid: true,
      commandDisabled: false
    };
  },
  computed: {
    deviceType() {
      if (this.$route.name.includes('ecotron')) {
        return 'EC';
      } else if (this.$route.name.includes('ecofrost')) {
        return 'EF';
      } else {
        return null;
      }
    },
    deviceId() {
      return this.$route.params.topic;
    }
  },
  methods: {
    async executeCommand(payload) {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          this.commandDisabled = true;
          const response = await axios({
            method: 'POST',
            baseURL: 'https://api.ecozen.ai/mqtt/v1',
            url: `${this.deviceType}/${this.deviceId}`,
            data: {
              command: this.command,
              timeout: 60000
            }
          });
          let result = '';
          if (response.data.messages.length > 0) {
            for (const m of response.data.messages) {
              let timestamp = `-----------------------------------[${dateFormat(
                m.timestamp
              )}]-----------------------------------`;
              result = `${result}${timestamp}\n${m.message}\n`;
            }
          }
          this.result = result;
        } catch (error) {
          if (error.response.data.error) {
            this.result = `${error.response.data.error.name}\n${error.response.data.error.message}`;
          } else {
            this.result = `${error}`;
          }
        }
      }
      this.loading = false;
      this.commandDisabled = false;
    }
  }
};
</script>
